import { selectWarehouse } from '../Warehouses/warehousesSlice'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import { useReduxSelector } from 'store'
import { selectConfig } from 'appSlice'
import { SECTION_TYPES } from '.'
import React from 'react'

interface ManageButtonProps {
  text: string
  icon: string
  disabled?: boolean
  action?: React.MouseEventHandler<HTMLElement>
}

const ManageButton: React.FC<ManageButtonProps> = ({ action, disabled, text, icon }) => <div
  className='menu__button center'
  onClick={disabled ? undefined : action}
  style={disabled ? { opacity: 0.5 } : undefined}>
  <i className={`icon icon--${icon} s24`} />
  <span>{text}</span>
</div>

interface MagManageProps {
  id: string
  isDesktop?: boolean
  goTo: (path: string) => void
}

const MagManage: React.FC<MagManageProps> = ({ id, isDesktop = false, goTo }) => {
  const { isShared, permissions, inFuture, hasOnlineAccess, gateHasOnlineAccess } = useReduxSelector(state => selectWarehouse(state, id))
  const config = useReduxSelector(selectConfig)

  const { push } = useHistory()
  const { t } = useTranslation('warehouse')

  const magDetails = <ManageButton
    icon='mag-details'
    text={t('rentalDetails')}
    action={() => {
      goTo(SECTION_TYPES.details)
    }}
  />
  const payments = <ManageButton
    icon='payments'
    text={t('invoices')}
    disabled={(isShared && !permissions?.includes('invoice')) || inFuture}
    action={() => {
      goTo(SECTION_TYPES.invoices)
    }}
  />
  const insurance = <ManageButton
    disabled
    icon='insurance'
    text={t('warehouseInsurance')}
  />
  const share = hasOnlineAccess && gateHasOnlineAccess && <ManageButton
    icon='share'
    text={t('manageAccess')}
    disabled={isShared && !permissions?.includes('share')}
    action={() => {
      goTo(SECTION_TYPES.access)
    }}
  />
  const help = <ManageButton
    icon='alarm'
    text={t('reportAFailure')}
    disabled={inFuture}
    action={() => {
      push(`/help?warehouseId=${id}`)
    }}
  />
  const accessories = config?.warehouseAccessoriesEnabled && <ManageButton
    icon='shopping-bag'
    text={t('magBoxAccessories')}
    action={() => {
      goTo(SECTION_TYPES.accessories)
    }}
  />

  return (
    <div className='menu__section menu__manage'>
      <p>{t('manageYourWarehouse')}</p>

      {isDesktop
        ? <div className='menu__buttons'>
          {magDetails}
          {payments}
          {insurance}
          {share}
          {help}
          {accessories}
        </div>
        : <div className='menu__buttons'>
          <div className='buttons__row center'>
            {magDetails}
            <hr />
            {payments}
            <hr />
            {insurance}
          </div>
          <hr />
          <div className='buttons__row center'>
            {share && <>
              {share}
              <hr />
            </>}
            {help}
            {accessories && <>
              <hr />
              {accessories}
            </>}
          </div>
        </div>}
    </div>
  )
}

export default MagManage